import styled from "@emotion/styled";
import { animated, useTransition } from "@react-spring/web";
import type { ComponentProps, FC } from "react";
import { useAppConfig } from "../../hooks/index.ts";
import { LoadingSpinner } from "./LoadingSpinner.tsx";

export const LoadingAnimation: FC<
  React.PropsWithChildren<{
    visible: boolean;
  }>
> = ({ visible }) => {
  const transitions = useTransition(visible, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  const config = useAppConfig();

  return transitions(
    (style, item) =>
      item && (
        <AnimatedOverlay style={style}>
          <LoadingSpinner icon={getContextualIcon(config)} size="5rem" />
        </AnimatedOverlay>
      ),
  );
};

const AnimatedOverlay = styled(animated.div)`
  position: fixed;
  z-index: 3000;

  inset: 0;

  display: flex;
  align-items: center;
  justify-content: center;
`;

function getContextualIcon(
  config: { league: { sport: string } } | null,
): ComponentProps<typeof LoadingSpinner>["icon"] | undefined {
  switch (config?.league.sport.toLowerCase()) {
    case "baseball":
      return "Baseball";
    case "basketball":
      return "Basketball";
    case "football":
      return "Football";
    case "hockey":
      return "Hockey";
    case "soccer":
      return "Soccer";
    default:
      return "Loading";
  }
}
